import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Handbook from './pages/Handbook';
import Investors from './pages/Investors';
import Users from './pages/Users';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail'; 

function App() {
  return (
    <>
      <Navbar />
      <div style={{ padding: '20px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/handbook" element={<Handbook />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/users" element={<Users />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} /> 
        </Routes>
      </div>
    </>
  );
}

export default App;
